export default __webpack_public_path__ + "static/reed-1--mobile-dc7ebf54ffcc02f70f7cf9c1d51267a5.webp";